import axios from 'axios';
import { generateUpdateGeometryXML, transformCoordinates } from "../XmlGenerators";
import { getAccessToken } from '../LoginForm/Auth/auth';

export const handleUpdateGeometry = async (
  currentDrawing,
  newCoordinates,
  layerCRS,
  typeName,
  geometryName,
  setIsUpdated
) => {
  const token = getAccessToken();
  let geometry;
  let flatCoords = [];

  // 📦 Normalizacija ulaznog formata
  if (Array.isArray(newCoordinates)) {
    // MultiLineString / Polygon
    if (Array.isArray(newCoordinates[0]) && Array.isArray(newCoordinates[0][0])) {
      geometry = {
        type: 'MultiLineString', // Ako znaš da je Polygon, zameni ručno
        coordinates: newCoordinates
      };
    }
    // LineString
    else if (Array.isArray(newCoordinates[0])) {
      geometry = {
        type: 'LineString',
        coordinates: newCoordinates
      };
    }
    // Point
    else {
      geometry = {
        type: 'Point',
        coordinates: newCoordinates
      };
    }
  } else if (newCoordinates?.type && newCoordinates?.coordinates) {
    geometry = newCoordinates;
  } else {
    console.error("❌ Invalid geometry format:", newCoordinates);
    return;
  }

  // 📉 Izravnavanje koordinata po tipu
  try {
    switch (geometry.type) {
      case "Point":
        flatCoords = geometry.coordinates;
        break;
      case "LineString":
      case "MultiPoint":
        flatCoords = geometry.coordinates.flat(1);
        break;
      case "Polygon":
      case "MultiLineString":
        flatCoords = geometry.coordinates.flat(2);
        break;
      case "MultiPolygon":
        flatCoords = geometry.coordinates.flat(3);
        break;
      default:
        console.error("❌ Unsupported geometry type:", geometry.type);
        return;
    }
  } catch (e) {
    console.error("❌ Failed to flatten coordinates:", geometry.coordinates, e);
    return;
  }

  // 🚨 Validacija svih brojeva
  const invalidValues = flatCoords.filter(c => typeof c !== 'number' || !isFinite(c));
  if (invalidValues.length > 0) {
    console.error("🚨 Invalid coordinate values found:", invalidValues);
    return;
  }

  // 🌍 Transformacija u ciljani CRS
  const transformedCoordinates = transformCoordinates(geometry.coordinates, "EPSG:4326", layerCRS);

  const xml = generateUpdateGeometryXML(
    currentDrawing.id,
    typeName,
    { type: geometry.type, coordinates: transformedCoordinates },
    layerCRS,
    geometryName
  );

  try {
    const response = await axios.post('/geoserver/wfs', xml, {
      headers: {
        'Content-Type': 'application/xml',
        'Authorization': `Bearer ${token}`
      }
    });

    setIsUpdated(true);
  } catch (error) {
    console.error('❌ Failed to update geometry:', error.response ? error.response.data : error.message);
  }
};
